<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      v-b-modal.form-employee-modal
      @click="cleanUpForm()"
    >
      Tambah
    </b-button>

    <b-modal
      id="form-employee-modal"
      no-close-on-backdrop
      size="lg"
      :title="(editId == null ? 'Tambah' : 'Edit') + ' Karyawan'"
    >
      <validation-observer ref="employeeValidation">
        <div class="form">
          <div class="row">
            <div class="col-6">
              
              <div class="form-group">
                <label >Nomor Induk Pegawai (NIP)</label>
                <validation-provider
                  #default="{ errors }"
                  name="employeeNumber"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.employeeNumber"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Nama</label>
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.fullName"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Email</label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.email"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >No HP</label>
                <validation-provider
                  #default="{ errors }"
                  name="phoneNumber"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.phoneNumber"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >No KTP</label>
                <validation-provider
                  #default="{ errors }"
                  name="legal_id"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.legalId"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >NPWP</label>
                <validation-provider
                  #default="{ errors }"
                  name="npwp"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.npwp"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Jenis Kelamin:</label>
                <validation-provider>
                    <b-form-select
                    v-model="formPayloadEmployee.genderId"
                    :options="genderList"
                    :reduce="gender => gender.value"
                    />
                </validation-provider>
                </div>

              <div class="form-group">
                <label >Tempat Lahir</label>
                <validation-provider
                  #default="{ errors }"
                  name="place_of_birth"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.placeOfBirth"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Tanggal Lahir</label>
                <validation-provider
                  #default="{ errors }"
                  name="date_of_birth"
                >

                  <b-form-input v-model="formPayloadEmployee.dateOfBirth" class="form-control" type="date"></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Agama :</label>
                <validation-provider>
                  
                    <b-form-select
                    v-model="formPayloadEmployee.religionId"
                    :options="religionList"
                    :reduce="religion => religion.value"
                    />
                </validation-provider>
                </div>

              <div class="form-group">
                <label >Status Perkawinan :</label>
                <validation-provider #default="{ errors }" name="status_maried" rules="required">
                    <b-form-select
                    v-model="formPayloadEmployee.maritalStatusId"
                    :options="maritalStatusList"
                    :reduce="marital => marital.value"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group">
                <label >Nama Pasangan</label>
                <validation-provider
                  #default="{ errors }"
                  name="marital_status"
                  :rules="isRequiredMaried"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.spouseName"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              







            </div>

            <div class="col-6">

                <div class="form-group">
                <label >Alamat</label>
                <validation-provider
                  #default="{ errors }"
                  name="address"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.address"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="col-6">

              </div>

              <div class="form-group">
                <label>Provinsi</label>
                  <validation-provider
                    #default="{ errors }"
                    name="provinceId"
                    rules="required"
                  >
                    <v-select size="sm"
                        placeholder="-- Pilih Provinsi --"
                        v-model="formPayloadEmployee.provinceId"
                        :options="provinceList"
                        :reduce="province => province.value"
                        label="text"
                        v-on:input="getCityData($event)"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
              </div>

              <div class="form-group">
                <label>Kota/Kab</label>
                  <validation-provider
                    #default="{ errors }"
                    name="cityId"
                    rules="required"
                  >
                    <v-select size="sm"
                        placeholder="-- Pilih Kota/Kab --"
                        v-model="formPayloadEmployee.cityId"
                        :options="cityList"
                        :reduce="city => city.value"
                        label="text"
                        v-on:input="getDistrictData($event)"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
              </div>

              <div class="form-group">
                <label>Kecamatan</label>
                  <validation-provider
                    #default="{ errors }"
                    name="districtId"
                    rules="required"
                  >
                    <v-select size="sm"
                        placeholder="-- Pilih Kecamatan --"
                        v-model="formPayloadEmployee.districtId"
                        :options="districtList"
                        :reduce="district => district.value"
                        label="text"
                        v-on:input="getVillageData($event)"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
              </div>

              <div class="form-group">
                <label>Kelurahan</label>
                  <validation-provider
                    #default="{ errors }"
                    name="villageId"
                    rules="required"
                  >
                    <v-select size="sm"
                        placeholder="-- Pilih Kelurahan --"
                        v-model="formPayloadEmployee.villageId"
                        :options="villageList"
                        :reduce="village => village.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
              </div>

              <!-- <div class="form-group">
                <label >Kecamatan</label>
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.title"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Kab/Kota</label>
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.title"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Provinsi</label>
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.title"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div> -->

              <div class="form-group">
                <label >Telp Rumah</label>
                <validation-provider
                  #default="{ errors }"
                  name="telephone"
                  rules=""

                >
                  <b-form-input
                    v-model="formPayloadEmployee.telephone"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Status Pegawai :</label>
                <validation-provider>
                    <b-form-select
                    v-model="formPayloadEmployee.employeeStatusId"
                    :options="employeeStatusList"
                    />
                </validation-provider>
                </div>

              <div class="form-group">
                <label >Tanggal Bergabung</label>
                <validation-provider
                  #default="{ errors }"
                  name="join_date"
                  rules="required"

                >
                  <b-form-input
                  type="date"
                  v-model="formPayloadEmployee.joinDate"
                  class="form-control"

                />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Gaji Pokok</label>
                <validation-provider
                  #default="{ errors }"
                  name="basic_salary"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.basicSalary"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Tanggal Resign/Pensiun</label>
                <validation-provider
                  #default="{ errors }"
                  name="resign_date"
                >
                  <b-form-input
                  v-model="formPayloadEmployee.dateResign"
                  class="form-control"
                  type="date"
                />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >Jumlah Anak</label>
                <validation-provider
                  #default="{ errors }"
                  name="child_quantity"
                  rules="required"

                >
                  <b-form-input
                    v-model="formPayloadEmployee.childQuantity"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group">
                <label >PTKP :</label>
                <validation-provider>
                    <b-form-select
                    v-model="formPayloadEmployee.ptkp"
                    :options="ptkpList"
                    />
                </validation-provider>
                </div>

            </div>



          </div>

        </div>
      </validation-observer>

      <template #modal-footer="{}">
        <div v-if="isLoadingAnnouncement">
          <br />
          <b-spinner class="mb-2" variant="primary" /><br />
        </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingAnnouncement"
          @click="submitItem()"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";

import flatPickr from 'vue-flatpickr-component'
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    formPayload: {
      type: "",
    },
    editPayload: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    editId: {
      type: "",
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    validations: {
      type: "",
    },
    imageAnnouncement: {
      type: String,
    },
    cleanUpForm: {
      type: Function,
    },
    genders: {
      type: '',
    },
    religions: {
      type: '',
    },
    maritalStatus: {
      type: '',
    },
    ptkp: {
      type: '',
    },
    employeeStatus: {
      type: '',
    },
    province: {
      type: '',
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      parents: [],
      isLoadingAnnouncement: false,
      formPayloadEmployee: {
        address: "",
        basicSalary: 0,
        childQuantity: 0,
        dateOfBirth: "",
        dateResign: "",
        email: "",
        employeeNumber: "",
        employeeStatusId: 0,
        fullName: "",
        genderId: 0,
        // imageProfile: "",
        joinDate: "",
        legalId: "",
        maritalStatusId: 0,
        npwp: "",
        phoneNumber: "",
        placeOfBirth: "",
        ptkp: 0,
        religionId: 0,
        spouseName: "",
        telephone: "",
        villageId: 0
      },
      isRequiredMaried:   '',
      genderList: [],
      religionList: [],
      maritalStatusList: [],
      ptkpList: [],
      employeeStatusList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      villageList: [],
    };
  },
  watch: {
    purpose(value) {
      this.purposeCoupon = value;
    },
    isLoading(value) {
      this.isLoadingAnnouncement = value;
    },
    validations(value) {
      this.validationsCategory = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadEmployee = value;
      },
      deep: true,
    },
    formPayloadEmployee: {
      handler(value) {
        this.$emit("payloadEmployee", value);
      },
      deep: true,
    },
    genders(value) {
      this.genderList = value
    },
    religions(value) {
      this.religionList = value
    },
    maritalStatus(value) {
      this.maritalStatusList = value
    },
    ptkp(value) {
      this.ptkpList = value
    },
    employeeStatus(value) {
      this.employeeStatusList = value
    },
    province(value) {
      this.provinceList = value;
    },
    editPayload(value) {
        if (value.provinceId !== null) {
            this.getCityData(value.provinceId)
            this.getDistrictData(value.cityId)
            this.getVillageData(value.districtId)
        }
    },
    'formPayloadEmployee.maritalStatusId': function(value) { 
      if (value === 20) {
        return this.isRequiredMaried  =   '';
      }
      return this.isRequiredMaried  =   'required';
    }
  },
  methods: {
    submitItem() {
      console.log('submititem')
      console.log(this.formPayloadEmployee);
      this.$refs.employeeValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
    changeImage(event) {
      // eslint-disable-next-line prefer-destructuring
      this.formPayloadEmployee.file = event.target.files[0];
    },
    getCityData(provinceId) {

      console.log('get city')
      console.log(provinceId)
      const queryParams = {
        provinceId: provinceId
      }

      this.$http.get("/mastering/city/all/" + provinceId, {  }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].cityId;
          result[i].text = result[i].cityName;
          delete result[i].key;
          delete result[i].label;
        }

        this.cityList = result;
      });
    },
    getDistrictData(cityId) {
     const queryParams = {
        cityId: cityId
      }

      this.$http.get("/mastering/district/all/" + cityId, { params: queryParams }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].districtId;
          result[i].text = result[i].districtName;
          delete result[i].key;
          delete result[i].label;
        }

        this.districtList = result;
      });
    },
    getVillageData(districtId) {
        const queryParams = {
        districtId: districtId
       }

      this.$http.get("/mastering/village/all/" + districtId, { params: queryParams }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].villageId;
          result[i].text = result[i].villageName;
          delete result[i].key;
          delete result[i].label;
        }

        this.villageList = result;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
